interface setCookieParams {
  value: string;
  expiresInMinutes: number;
  key: string;
}

export const setCookie = ({ value, expiresInMinutes, key }: setCookieParams) => {
  const d = new Date();
  d.setTime(d.getTime() + expiresInMinutes * 60 * 1000);
  document.cookie = `${key}=${value}; expires=${d.toUTCString()}; path=/`;
};

export const getCookie = (key: string): string | null => {
  const cookies = document.cookie.split(';').map(c => c.trim());
  const cookie = cookies.find(c => c.startsWith(`${key}=`));
  return cookie ? cookie.split('=')[1] : null;
};